import { render, staticRenderFns } from "./WrapCarousel.vue?vue&type=template&id=704c819e&"
import script from "./WrapCarousel.vue?vue&type=script&lang=js&"
export * from "./WrapCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports